// spriteInjector.ts
const injected = new WeakSet<Document | ShadowRoot>();
const inflight = new WeakMap<Document | ShadowRoot, Promise<void>>();

export async function ensureSpriteInjected(target: Document | ShadowRoot, spriteUrl: string) {
  if (injected.has(target)) return;
  if (inflight.has(target)) return inflight.get(target)!;

  const fetchRequest = (async () => {
    const res = await fetch(spriteUrl, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Sprite wasn't loaded: ${spriteUrl}`);
    const svgText = await res.text();

    const container = (target.ownerDocument ?? (target as Document)).createElement('div');
    container.setAttribute('aria-hidden', 'true');
    container.style.cssText = 'position:absolute; width:0; height:0; overflow:hidden;';
    container.innerHTML = svgText;

    if ('head' in target && target.head) {
      target.head.prepend(container);
    } else {
      (target as ShadowRoot).prepend(container);
    }

    injected.add(target);
  })();

  inflight.set(target, fetchRequest);
  try {
    await fetchRequest;
  } finally {
    inflight.delete(target);
  }
}
